import Backbone from 'backbone';

export const NotificationThreadCollection = Backbone.Collection.extend({
	
	comparator: 'unix'

});